/* Centralized company + contact + routes + copy. */
export const COMPANY = {
    name: "Kche Diversiones",
    shortName: "Kche",
    tagline: 'Diversión para toda la familia en Pifo, Quito.',
    logo: 'https://customer-assets.emergentagent.com/job_puyo-adventure-build/artifacts/aj7oe5cg_image-removebg-preview%20%284%29.png',
    emprenovusLogo: 'https://customer-assets.emergentagent.com/job_027fab5c-5f5a-4417-a7d7-74cb1ef48c7f/artifacts/f2abwqes_Emprenovus.png',
    phone: '+593 98 351 7147',
    phoneRaw: '593983517147',
    whatsapp: 'https://wa.me/593983517147',
    address:
        'Carretera E35 arterial km 241 Quito, Ecuador',
    mapsShortUrl: 'https://maps.app.goo.gl/pqDoBEqysbpW8CzFA',
    mapsLat: -0.2300743,
    mapsLng: -78.325875,
    mapsEmbedUrl:
        'https://www.google.com/maps?q=-0.2300743,-78.325875&z=17&output=embed',
    mapsQuery:
        'Carretera E35 arterial km 241 + 100 sentido Palugo, Intercambiador de, 170175 Quito, Ecuador',
    instagramHandle: '@kche.diversiones',
    instagramUrl: 'https://www.instagram.com/kche.diversiones/',
    tiktokHandle: '@kchediversiones',
    tiktokUrl: 'https://www.tiktok.com/@kchediversiones',
    facebookHandle: 'Kche Diversiones',
    facebookUrl: 'https://www.facebook.com/kchediversiones',
    email: 'info@kchediversiones.com',
    hoursPlaceholder: 'Horarios pendientes de confirmación',
};

export const getCompanyWhatsAppNumber = () => {
    const phoneRaw = String(COMPANY.phoneRaw || '').replace(/\D/g, '');

    if (phoneRaw) {
        return phoneRaw;
    }

    const whatsappMatch = String(COMPANY.whatsapp || '').match(
        /wa\.me\/(\d+)/
    );

    if (whatsappMatch?.[1]) {
        return whatsappMatch[1];
    }

    return String(COMPANY.phone || '').replace(/\D/g, '');
};

export const buildCompanyWhatsAppUrl = (message = '') => {
    const number = getCompanyWhatsAppNumber();

    if (!number) {
        return '';
    }

    const cleanMessage = String(message || '').trim();

    return cleanMessage
        ? `https://wa.me/${number}?text=${encodeURIComponent(cleanMessage)}`
        : `https://wa.me/${number}`;
};

export const CONTACT = {
    whatsapp: COMPANY.whatsapp,
    phone: COMPANY.phone,
    instagram: COMPANY.instagramUrl,
    tiktok: COMPANY.tiktokUrl,
    address: COMPANY.address,
    mapsUrl: COMPANY.mapsShortUrl,
};

export const ROUTES = {
    home: '/',
    atracciones: '/atracciones',
    cumple: '/cumpleanos-y-eventos',
    nosotros: '/nosotros',
    contacto: '/contacto',
    privacidad: '/politica-de-privacidad',
    normativas: '/normativas-del-parque',
    adminLogin: '/admin/login',
    adminDashboard: '/admin/dashboard',
    adminLeads: '/admin/leads',
    adminReservations: '/admin/reservations',
    adminAttractions: '/admin/attractions',
    adminEvents: '/admin/events',
    adminContent: '/admin/content',
    adminMedia: '/admin/media',
    adminSocial: '/admin/social',
    adminSettings: '/admin/settings',
    adminAnalytics: '/admin/analytics',
    adminActivity: '/admin/activity',
    adminBackup: '/admin/backup',
};



export const ATTRACTION_CATEGORIES = [
    { key: 'acuaticos', label: 'Acuáticos' },
    { key: 'competencia', label: 'Competencia' },
    { key: 'deportivos', label: 'Deportivos' },
    { key: 'interactivos', label: 'Interactivos' },
    { key: 'mecanicos', label: 'Mecánicos' },
    { key: 'otros', label: 'Otros' },
];

export const ATTRACTION_CATEGORY_LABELS = ATTRACTION_CATEGORIES.reduce((acc, item) => {
    acc[item.key] = item.label;
    return acc;
}, {});

export const RESERVATIONS_ENABLED = false;

export const RESERVATION_DISABLED_MESSAGE =
    'Sistema de Reserva no disponible por el momento';

export const NAV_LINKS = [
    { to: ROUTES.home, label: 'Inicio' },
    { to: ROUTES.atracciones, label: 'Atracciones' },
    { to: ROUTES.cumple, label: 'Cumpleaños y Eventos' },
    { to: ROUTES.nosotros, label: 'Nosotros' },
    { to: ROUTES.contacto, label: 'Contacto' },
];

export const ADMIN_NAV = [
    { to: ROUTES.adminDashboard, label: 'Dashboard', icon: 'LayoutDashboard' },
    { to: ROUTES.adminReservations, label: 'Reservas', icon: 'CalendarCheck' },
    { to: ROUTES.adminLeads, label: 'Leads', icon: 'Users' },
    { to: ROUTES.adminAttractions, label: 'Atracciones', icon: 'Rocket' },
    { to: ROUTES.adminEvents, label: 'Cumple y Eventos', icon: 'PartyPopper' },
    { to: ROUTES.adminContent, label: 'Contenido', icon: 'FileText' },
    { to: ROUTES.adminMedia, label: 'Media', icon: 'Image' },
    { to: ROUTES.adminSocial, label: 'Social', icon: 'Hash' },
    { to: ROUTES.adminAnalytics, label: 'Analíticas', icon: 'BarChart3' },
    { to: ROUTES.adminSettings, label: 'Configuración', icon: 'Settings' },
    { to: ROUTES.adminActivity, label: 'Actividad', icon: 'Activity' },
    { to: ROUTES.adminBackup, label: 'Backup', icon: 'Database' },
];

export const COPY = {
    heroDefault: {
        headline: '¡Los juegos más grandes del país llegaron al Pifo!',
        subheadline:
            'Diversión para niños, jóvenes y adultos en un espacio pensado para compartir en familia.',
        ctaPrimary: 'Reserva Online',
        ctaSecondary: 'Ver atracciones',
    },
    aventura: [
        { key: 'ninos', title: 'Niños', icon: 'Baby', desc: 'Atracciones seguras y divertidas para los más pequeños.' },
        { key: 'jovenes', title: 'Jóvenes', icon: 'Gamepad2', desc: 'Adrenalina, retos y experiencias arcade inolvidables.' },
        { key: 'adultos', title: 'Adultos', icon: 'Sparkles', desc: 'Comparte y diviértete con tu familia y amigos.' },
    ],
    safety: [
        { title: 'Supervisión', desc: 'Personal atento durante toda la experiencia.', icon: 'Eye' },
        { title: 'Mantenimiento', desc: 'Revisión periódica de los juegos.', icon: 'Wrench' },
        { title: 'Higiene', desc: 'Protocolos de limpieza y cuidado.', icon: 'SprayCan' },
        { title: 'Familiar', desc: 'Ambiente pensado para todas las edades.', icon: 'Heart' },
    ],
    fallbackHeroImages: [
    ],
};

export const ABOUT_CONTENT = {
    title: "Sobre K'che Diversiones Pifo",
    intro:
        'En K’che Diversiones creamos experiencias para compartir, jugar y recordar en familia, con atracciones pensadas para niños, jóvenes y adultos.',
    mission:
        'Brindar experiencias de diversión seguras, innovadoras e inolvidables para niños, jóvenes y familias, a través de parques inflables, actividades recreativas y un servicio de excelencia, fomentando la unión familiar y creando recuerdos que perduren para siempre.',
    vision:
        'Ser la empresa líder en entretenimiento familiar del Ecuador, reconocida por ofrecer los parques inflables más innovadores, seguros y emocionantes del país, expandiendo nuestra presencia a nivel nacional y convirtiéndonos en un referente de diversión para todas las generaciones.',
    values: [
        {
            key: 'seguridad',
            title: 'Seguridad ante todo',
            desc: 'La diversión comienza con confianza y cuidado.',
            icon: 'ShieldCheck',
        },
        {
            key: 'servicio',
            title: 'Servicio con amabilidad y respeto',
            desc: 'Atención cercana para que cada visita se sienta especial.',
            icon: 'SmilePlus',
        },
        {
            key: 'innovacion',
            title: 'Innovación constante',
            desc: 'Experiencias recreativas cada vez más atractivas.',
            icon: 'Lightbulb',
        },
        {
            key: 'equipo',
            title: 'Trabajo en equipo',
            desc: 'Un equipo alineado para crear mejores momentos.',
            icon: 'Users',
        },
        {
            key: 'honestidad',
            title: 'Honestidad y responsabilidad',
            desc: 'Compromiso claro con cada visitante y familia.',
            icon: 'BadgeCheck',
        },
        {
            key: 'familia',
            title: 'Diversión para toda la familia',
            desc: 'Espacios pensados para niños, jóvenes y adultos.',
            icon: 'Heart',
        },
        {
            key: 'clientes',
            title: 'Compromiso con nuestros clientes',
            desc: 'Escuchar, acompañar y mejorar cada experiencia.',
            icon: 'HeartHandshake',
        },
    ],
};

export const SOURCES_LABEL = {
    contact_form: 'Formulario contacto',
    event_form: 'Formulario eventos',
    home_event: 'Home (Cumpleaños y Eventos)',
    quick_strip: 'CTA rápido',
    hero: 'Hero',
    other: 'Otro',
};

export const STATUS_LABEL = {
    new: 'Nuevo',
    contacted: 'Contactado',
    in_progress: 'En proceso',
    won: 'Ganado',
    lost: 'Perdido',
};

export const STATUS_COLORS = {
    new: 'bg-sky-100 text-sky-700 border-sky-200',
    contacted: 'bg-amber-100 text-amber-700 border-amber-200',
    in_progress: 'bg-violet-100 text-violet-700 border-violet-200',
    won: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    lost: 'bg-rose-100 text-rose-700 border-rose-200',
};

export const RESERVATION_TYPES = [
    { value: 'visita_general', label: 'Visita general' },
    { value: 'cumpleanos', label: 'Cumpleaños' },
    { value: 'evento', label: 'Evento' },
    { value: 'grupo_escuela', label: 'Grupo / Escuela' },
    { value: 'otro', label: 'Otro' },
];

export const RESERVATION_STATUS = {
    new: 'Nueva',
    contacted: 'Contactada',
    in_progress: 'En proceso',
    confirmed: 'Confirmada',
    cancelled: 'Cancelada',
};

export const RESERVATION_STATUS_COLORS = {
    new: 'bg-sky-100 text-sky-700 border-sky-200',
    contacted: 'bg-amber-100 text-amber-700 border-amber-200',
    in_progress: 'bg-violet-100 text-violet-700 border-violet-200',
    confirmed: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    cancelled: 'bg-rose-100 text-rose-700 border-rose-200',
};
